import type { Permission } from '@tmapy/config';

import { SET_PERMISSIONS } from '../../src/constants';

export const actionSetPermission = (permissions: Permission[]) =>
  ({
    type: SET_PERMISSIONS,
    payload: permissions,
  }) as const;
